@if (configuration.display && configuration.download) {
<fa-icon
    title="{{ configuration.downloadTitle }}"
    class="ras-btn-link"
    rasProposal
    [branchPhone]="data?.branch_phone"
    [equipmentId]="data?.equipment_number"
    [icon]="['fas', 'download']"
>
</fa-icon>
} @if (configuration.display) {
<fa-icon
    [icon]="['fas', 'share']"
    title="{{ configuration.shareTitle }}"
    class="ras-btn-link"
    (click)="onShare()"
>
</fa-icon>
}
